import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { SubmitButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { getFieldsLabel, getRequiredFieldsWithError } from '@bit/wavfichacerta.fichacerta.forms-utils.extractors';
import Loading from '@bit/wavfichacerta.fichacerta.icons.loading';

export class StepButton extends PureComponent {
  getDefaultButtonStyle = () => ({
    minWidth: '84px',
    height: '32px',
    padding: '0 .95rem',
    margin: 0,
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    background: 'linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)',
    boxShadow: '0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25)',
    color: '#fff',
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  })

  static defaultProps = {
    onChangeStep: () => { },
    showBackButton: false,
    sending: false,
    label: undefined
  }

  onClickButton = () => {
    const { forms, allForms, usedFields, onChangeStep, entity } = this.props;

    if (allForms[forms[0]] !== undefined && typeof allForms === "object") {

      const emptyRequiredFields = getRequiredFieldsWithError(allForms, entity);
      const labels = getFieldsLabel(emptyRequiredFields, usedFields);

      if (labels.length > 0) {
        onChangeStep(allForms, labels);
      } else {
        onChangeStep(allForms);
      }

    }
  }

  getButtonSettings = () => {
    const { forms, currentStep, label } = this.props;
    if (label) {
      return label;
    }
    let formsQuantity = Array.isArray(forms) ? forms.length : 0;
    let labelButton = 'Avançar';

    if (formsQuantity === 1) {
      labelButton = 'Salvar';
    }

    if (currentStep === formsQuantity) {
      labelButton = 'Salvar';
    }
    return labelButton;
  }

  renderGoBackButton = () => {
    if (this.props.showBackButton) {
      return (
        <SubmitButton
          onClick={this.props.goBack}
          customstyle={{ ...this.getDefaultButtonStyle(), marginRight: '1rem' }}
        >
          Cancelar
        </SubmitButton>
      )
    }
  }

  render() {
    return (
      <StyledRow justify="center" padding="1rem 0">
        {this.renderGoBackButton()}
        <SubmitButton
          disabled={this.props.sending}
          data-testid="StepButton"
          color="color_white"
          onClick={this.onClickButton}
          customstyle={this.getDefaultButtonStyle()}
        >
          {(this.props.sending) ?
            <Loading width="2.45rem" height="1.35rem" />
            :
            this.getButtonSettings()
          }
        </SubmitButton>
      </StyledRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  allForms: state.form
});

export default connect(mapStateToProps, null)(StepButton);